export default "__VITE_ASSET__z2e6Fttz__"